"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const css_in_js_1 = require("../../components/css-in-js");
exports.styles = {
    actionButton: (0, css_in_js_1.css) `
        text-transform: none;
        font-weight: 300;
        padding: 0px;
        cursor: pointer;
    `,
};
//# sourceMappingURL=PageBannerStyles.js.map